module.exports = "/assets/ad06accff34ade849ea68ba0a4bd9d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/L9.png
// module id = 1571
// module chunks = 0